const PREFIX = '/v1/CollectiveProject/Community'

export const URL = {
  ADD: PREFIX + '/add',
  DEL: PREFIX + '/delete',
  EDIT: PREFIX + '/edit',
  LIST: PREFIX + '/list',
  DETAIL: PREFIX + '/view',
  ENABLE: PREFIX + '/able',
  DISABLE: PREFIX + '/disable',
  ORDER: PREFIX + '/order',
  SETTLE_LIST: PREFIX + '/placeView',
  ANA1: PREFIX + '/placeMap',
  ANA2: PREFIX + '/placeMap2'
}
